import { createIcon } from '../icon'
import FilterIconRedesign from '@/components/atoms/svg/FilterIconRedesign'

export const FilterIconRedesignDefault = createIcon(FilterIconRedesign)
